

const InvoiceReducer = (state, action) => {
    switch (action.type) {
        case "GET_INVOICES_START":
            return {
                ...state,
                invoices: [],
                isFetching: true,
                error: false,
            };
        case "GET_INVOICES_SUCCESS":
            return {
                ...state,
                invoices: action.payload.invoices,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_INVOICES_FAILURE":
            return {
                ...state,
                invoices: [],
                isFetching: false,
                error: action.payload,
            };
        case "GET_ENVOIS_RAMASSAGE_DEPOT_START":
            return {
                ...state,
                envois: [],
                allEnvois: [],
                historiesRamassage: {},
                historiesDepot: {},
                isFetchingEnvoisRamassageDepot: true,
                errorEnvoisRamassageDepot: false,
            };
        case "GET_ENVOIS_RAMASSAGE_DEPOT_SUCCESS":
            return {
                ...state,
                envois: action.payload.envois,
                allEnvois: action.payload.allEnvois,
                count: action.payload.count,
                countGlobal: action.payload.countGlobal,
                sumCost: action.payload.sumCost,
                sumMontant: action.payload.sumMontant,
                historiesRamassage: action.payload.historiesRamassage,
                historiesDepot: action.payload.historiesDepot,
                isFetchingEnvoisRamassageDepot: false,
                errorEnvoisRamassageDepot: false,
            };
        case "GET_ENVOIS_RAMASSAGE_DEPOT_FAILURE":
            return {
                ...state,
                envois: [],
                allEnvois: [],
                historiesRamassage: {},
                historiesDepot: {},
                isFetchingEnvoisRamassageDepot: false,
                errorEnvoisRamassageDepot: action.payload,
            };
        case "GET_DETAIL_INVOICE_ENVOIS_RAMASSAGE_DEPOT_START":
            return {
                ...state,
                invoice: {},
                settings: {},
                envois: [],
                envoisDownload: [],
                historiesRamassage: [],
                historiesDepot: [],
                isFetchingEnvoisRamassageDepot: true,
                errorEnvoisRamassageDepot: false,
            };
        case "GET_DETAIL_INVOICE_ENVOIS_RAMASSAGE_DEPOT_SUCCESS":
            return {
                ...state,
                invoice: action.payload.invoice,
                settings: action.payload.settings,
                envois: action.payload.envois,
                envoisDownload: action.payload.envoisDownload,
                count: action.payload.count,
                countGlobal: action.payload.countGlobal,
                historiesRamassage: action.payload.historiesRamassage,
                historiesDepot: action.payload.historiesDepot,
                isFetchingEnvoisRamassageDepot: false,
                errorEnvoisRamassageDepot: false,
            };
        case "GET_DETAIL_INVOICE_ENVOIS_RAMASSAGE_DEPOT_FAILURE":
            return {
                ...state,
                invoice: {},
                settings: {},
                envois: [],
                envoisDownload: [],
                historiesRamassage: [],
                historiesDepot: [],
                isFetchingEnvoisRamassageDepot: false,
                errorEnvoisRamassageDepot: action.payload,
            };
        case "ADD_INVOICE_START":
            return {
                ...state,
                invoice: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_INVOICE_SUCCESS":
            return {
                ...state,
                invoice: action.payload.invoice,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_INVOICE_FAILURE":
            return {
                ...state,
                invoice: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_INVOICE_START":
            return {
                ...state,
                invoice: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_INVOICE_SUCCESS":
            return {
                ...state,
                invoice: action.payload.invoice,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_INVOICE_FAILURE":
            return {
                ...state,
                invoice: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "DELETE_INVOICE_START":
            return {
                ...state,
                message: "",
                isFetchingDelete: true,
                errorDelete: false,
            };
        case "DELETE_INVOICE_SUCCESS":
            return {
                ...state,
                message: action.payload.message,
                isFetchingDelete: false,
                errorDelete: false,
            };
        case "DELETE_INVOICE_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingDelete: false,
                errorDelete: action.payload,
            };
        case "CLEAR_INVOICE":
            return {
                ...state,
                message: "",
                invoice: {},
                settings: {},
                envois: [],
                allEnvois: [],
                envoisDownload: [],
                historiesRamassage: [],
                historiesDepot: [],
                isFetchingAdd: false,
                errorAdd: false,
            };
        default:
            return { ...state };
    }
}

export default InvoiceReducer;